/**
 =========================================================
 * Material Dashboard 2 PRO React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

const form = {
  formId: "edit-user-form",
  formField: {
    first_name: {
      name: "first_name",
      label: "First Name",
      type: "text",
      errorMsg: "First name is required.",
    },
    last_name: {
      name: "last_name",
      label: "Last Name",
      type: "text",
      errorMsg: "Last name is required.",
    },
    gender: {
      name: "gender",
      label: "Gender",
      type: "text",
      errorMsg: "Gender is required.",
    },
    // birth_day: {
    //   name: "birth_day",
    //   label: "Birth Date",
    //   type: "text",
    //   errorMsg: "Birth date is required.",
    // },
    email: {
      name: "email",
      label: "Email",
      type: "text",
      errorMsg: "Email is required.",
    },
    phone: {
      name: "phone",
      label: "Phone Number",
      type: "text",
      errorMsg: "Phone Number is required.",
    },
    avatar: {
      name: "avatar",
      label: "avatar",
      type: "file",
      errorMsg: "Avatar is required.",
    }
  },
};

export default form;
